module.exports = __webpack_public_path__ + "media/recipes/123-906c960c.png";